import { render } from "./PhoneInput.vue?vue&type=template&id=4a508d87"
import script from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/PhoneInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a508d87"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a508d87', __exports__)) {
    api.reload('4a508d87', __exports__)
  }
  
  module.hot.accept("./PhoneInput.vue?vue&type=template&id=4a508d87", () => {
    api.rerender('4a508d87', render)
  })

}


export default __exports__